import { PageContainer } from '../../components/ui/PageContainer';
import { SetupWizard } from '../../components/admin/SetupWizard';
import { Settings } from 'lucide-react';

export function Setup() {
  return (
    <PageContainer>
      <div className="mb-6 flex items-center gap-3">
        <Settings className="w-8 h-8 text-primary-400" />
        <div>
          <h1 className="text-2xl font-bold">Configuração Inicial</h1>
          <p className="text-gray-400">Complete os passos abaixo para configurar seu tenant e começar a operar</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto">
        <SetupWizard />
      </div>
    </PageContainer>
  );
}
